import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Services = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const services = [
    {
      title: "Soil Testing",
      image: "images/services/DSC_1813.JPG",
      link: "/soil",
      desc: "Our deep understanding of local soil profiles ensures safe foundations and lasting structural integrity.",
    },
    {
      title: "Geophysical Testing",
      image: "images/services/DSC_2306.JPG",
      link: "/geophysical",
      desc: "Discover what lies beneath with IMT’s precise subsurface analysis, ensuring data-driven decisions for your project.",
    },
    {
      title: "Concrete Testing",
      image: "images/services/DSC_1796.JPG",
      link: "/concrete",
      desc: "From field samples to lab analysis, IMT provides reliable testing to verify the strength and durability of your concrete.",
    },
    {
      title: "Asphalt Testing",
      image: "images/services/DSC_1793.JPG",
      link: "/asphalt",
      desc: "Our asphalt testing services guarantee top-quality surfaces through rigorous quality assurance and control testing.",
    },
  ];

  return (
    <section id="service-sec" className="services-section py-5">
      <div className="container">
        <div className="title-area text-center mb-5" data-aos="fade-up">
          <div className="shadow-title">Services</div>
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots" />
            </span>
            What We Offer{" "}
            <span className="shape right">
              <span className="dots" />
            </span>
          </span>
          <h2 className="sec-title fw-semibold">
            Professional Testing Services You Can Rely On
          </h2>
        </div>

        <div className="row g-4 justify-content-center">
          {services.map((service, index) => (
            <div
              className="col-md-6 col-lg-5 col-xl-4"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="service-card h-100 d-flex flex-column overflow-hidden position-relative">
                <div className="service-image position-relative overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-100"
                  />
                  <div className="image-overlay"></div>
                </div>
                <div className="service-content p-4 text-start flex-grow-1 d-flex flex-column">
                  <h5 className="fw-bold mb-3">{service.title}</h5>
                  <p className="text-muted mb-4">{service.desc}</p>
                  <div className="mt-auto">
                    <a href={service.link} className="btn learn-more-btn">
                      Learn More →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .services-section {
          background-color: #ffffff;
        }

        .service-card {
          border-radius: 20px;
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(10px);
          border: 2px solid rgba(7,115,37,0.15);
          transition: all 0.5s ease;
          box-shadow: 0 0 20px rgba(0,0,0,0.05);
        }

        .service-card:hover {
          transform: translateY(-12px) scale(1.03);
          box-shadow: 0 1.5rem 2.5rem rgba(7, 115, 37, 0.25);
          border-color: #077325;
        }

        .service-image img {
          height: 240px;
          object-fit: cover;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          transition: transform 0.6s ease;
        }

        .service-card:hover .service-image img {
          transform: scale(1.08);
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, rgba(0,0,0,0.1), transparent 60%);
          transition: opacity 0.5s ease;
        }

        .service-content h5 {
          color: #077325;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .learn-more-btn {
          border: 2px solid #077325;
          color: #077325;
          background: transparent;
          border-radius: 50px;
          padding: 8px 24px;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .learn-more-btn:hover {
          background-color: #077325;
          color: #fff;
          text-decoration: none;
        }
      `}</style>
    </section>
  );
};

export default Services;
